import { InfoIcon } from '@rsos/base-assets/icons';
import { Box } from '@rsos/base-components';
import styled from '@rsos/theme/styled';

export const Wrapper = styled(Box)`
  background: ${({ theme }) => theme.colors.primaryBase};
  border-radius: 5px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const TextContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledInfoIcon = styled(InfoIcon)`
  margin-right: 12px;
`;
